
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/headless/messages",
      function () {
        return require("private-next-pages/x/react-chat/headless/messages.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/headless/messages"])
      });
    }
  